import m from "../../geodata/es2015/boliviaLow";
window.am4geodata_boliviaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/boliviaLow.js
// module id = null
// module chunks = 